import { alpha, useTheme } from '@mui/material'
import { CalendarEventType } from 'src/generated-types/calendarEvent'
import { MUIThemeColors } from 'src/mui-theme'
import { getThemeColor } from 'src/utils'

// Identity colour per type (used for legend dots).
export const calendarTypeColor: Record<CalendarEventType, MUIThemeColors> = {
  Deviation: MUIThemeColors.errorMain,
  Service: MUIThemeColors.infoMain,
  WorkOrder: MUIThemeColors.successMain,
  Document: MUIThemeColors.warningMain,
}

const calendarTypeDarkColor: Record<CalendarEventType, MUIThemeColors> = {
  Deviation: MUIThemeColors.errorDark,
  Service: MUIThemeColors.infoDark,
  WorkOrder: MUIThemeColors.successDark,
  Document: MUIThemeColors.warningDark,
}

export interface CalendarTypeStyle {
  main: string
  text: string
  tint: string
  accent: string
}

// Soft, low-saturation palette derived from the theme: tinted surface + deep readable text.
export const useCalendarTypeStyle = () => {
  const theme = useTheme()
  return (type: CalendarEventType): CalendarTypeStyle => {
    const main = getThemeColor(theme, calendarTypeColor[type])
    const dark = getThemeColor(theme, calendarTypeDarkColor[type])
    return { main, text: dark, tint: alpha(main, 0.13), accent: main }
  }
}
